import type { HTMLAttributes, ReactNode } from "react";
import { classNames } from "helpers/commonHelpers";
import CardAccordion from "./components/CardAccordion/CardAccordion";
import CardHeader from "./components/CardHeader/CardHeader";
import CardLineItem from "./components/CardLineItem/CardLineItem";
import "./Card.scss";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Border radius of the card.
   *
   * none | xxs | xs | sm | md | lg | xl | 2xl | 3xl | 4xl | full
   */
  borderRadius: "none" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "full";
  /**
   * Box shadow of the card.
   *
   * none | "xs" | "sm"
   */
  shadow?: "none" | "xs" | "sm";
  /**
   * The style of the card.
   */
  style?: React.CSSProperties;
  /**
   * The children of the card item.
   */
  children: ReactNode;
}

interface CardBodyProps {
  children: ReactNode;
}

const Card = function ({ borderRadius = "xs", shadow = "sm", style, className, children, ...rest }: CardProps) {
  return (
    <div
      {...rest}
      style={style}
      className={classNames(`v2-card bg-primary shadow-${shadow} radius-${borderRadius}`, className ?? "")}
    >
      {children}
    </div>
  );
};

const CardBody = function ({ children }: CardBodyProps) {
  return <div className="v2-card--body">{children}</div>;
};

Card.Body = CardBody;
Card.Header = CardHeader;
Card.LineItem = CardLineItem;
Card.Accordion = CardAccordion;

Card.defaultProps = {
  shadow: "sm" as "none" | "xs" | "sm",
  style: {},
};

export default Card;
